import React from 'react';
import ReactApexChart from "react-apexcharts";
import { NoDataMessage } from '../common/NoDataMessage';

export const ChartWrapper = ({ 
    type, 
    data, 
    options, 
    height = 250, 
    noDataIcon, 
    noDataMessage 
}) => {
    const hasData = data && (
        (Array.isArray(data) && data.length > 0) || 
        (typeof data === 'object' && Object.keys(data).length > 0)
    );

    if (!hasData) {
        return <NoDataMessage icon={noDataIcon} message={noDataMessage} />;
    }

    return (
        <ReactApexChart
            type={type}
            options={options}
            series={data}
            height={height}
        />
    );
}; 